import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import onboardInstructorLogin from "../graph-ql/onboardInstructorLogin.graphql";

const useMutationOnboardInstructorLogin = ({
  onCompleted,
  onError,
}: MutationHookOptions) =>
  useMutation(onboardInstructorLogin, {
    onCompleted,
    onError,
  });

export default useMutationOnboardInstructorLogin;
